



























































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface, Typography } from '@/components/atoms';
import {
  CampaignStatus,
  CampaignStatistics,
  CampaignSettings
} from '@/components/organisms/OfferFreeCoins/DataPresentation';

import AnalyticsService from '@/api/AnalyticsService';
import PerformanceUtils from '@/utils/PerformanceUtils';

@Component({
  components: {
    Surface,
    Typography,
    CampaignStatistics,
    CampaignStatus,
    CampaignSettings
  }
})
export default class CampaignListItem extends Vue {
  @Prop({ default: false }) readonly hasActiveCampaign?: boolean;
  @Prop() readonly campaign: any;

  analyticsService: AnalyticsService = new AnalyticsService();

  get chartSeries() {
    return PerformanceUtils.normalizedChartSeries({
      ...this.campaign.chart,
      datasets: [{ ...this.campaign.chart.datasets, label: 'Members' }]
    });
  }

  get coins() {
    return Number(this.campaign.coinsReward);
  }

  get customers() {
    return this.campaign.customerLimit;
  }

  get visibilityType() {
    return this.campaign.visibilityType;
  }

  get expiration() {
    return this.campaign.dateLimit;
  }

  get status() {
    return this.campaign.status === 'active';
  }

  get customerLimitType() {
    return this.campaign.limitType;
  }
}
